import Vue from 'vue';

export default class ListUtils {
  static loadItemsData (instance, config) {
    instance.loaded = false;
    instance.loadError = false;

    instance.$http.post(config.endpoint, config.params).then(response => {
      if (config.noDataField) {
        if (typeof config.listField === 'string') {
          instance[config.listField] = response.data;
        } else {
          for (let i = 0; i < config.listField.length; i++) {
            let key = config.listField[i];
            Vue.set(instance.data, key, response.data[key]);
          }
        }
      } else {
        // eslint-disable-next-line
        instance[config.listField] = response.data.data;
      }

      instance.loaded = true;

      if (config.successAction) {
        config.successAction();
      }

      if (config.pagination) {
        instance.paginationMetaData = response.data.meta || null;
      }
    }).catch(error => {
      console.log(error);
      instance.loadError = true;
    });
  }

  static removeItem (instance, config) {
    Vue.swal({
      title: config.confirmTitle,
      text: config.confirmText,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Tak, usuń',
      cancelButtonText: 'Anuluj'
    }).then((result) => {
      if (result.value) {
        instance.$http.post(config.endpointBase + config.id).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: config.successText,
              icon: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: config.errorText,
              icon: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });
          }
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: config.errorTitle,
            html: config.errorText,
            icon: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }
}
